import { render, staticRenderFns } from "./Sign-In.vue?vue&type=template&id=4dedb310"
import script from "./Sign-In.vue?vue&type=script&lang=js"
export * from "./Sign-In.vue?vue&type=script&lang=js"
import style0 from "./Sign-In.vue?vue&type=style&index=0&id=4dedb310&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports